// src/state/menu/types/items_types.ts
var TCustomizerShape = /* @__PURE__ */ ((TCustomizerShape2) => {
  TCustomizerShape2["SQUARE"] = "square";
  TCustomizerShape2["ROUND"] = "round";
  return TCustomizerShape2;
})(TCustomizerShape || {});
var TAllModsBehavior = /* @__PURE__ */ ((TAllModsBehavior2) => {
  TAllModsBehavior2["ALL"] = "all";
  TAllModsBehavior2["ASSOCIATED"] = "associated";
  TAllModsBehavior2["PREMADE"] = "premade";
  return TAllModsBehavior2;
})(TAllModsBehavior || {});
var EItemDimensionsSellBy = /* @__PURE__ */ ((EItemDimensionsSellBy2) => {
  EItemDimensionsSellBy2["UNIT"] = "unit";
  EItemDimensionsSellBy2["VOLUME"] = "volume";
  EItemDimensionsSellBy2["WEIGHT"] = "weight";
  return EItemDimensionsSellBy2;
})(EItemDimensionsSellBy || {});
var EStockZeroActions = /* @__PURE__ */ ((EStockZeroActions2) => {
  EStockZeroActions2["RESET_TO_INITIAL"] = "resetToInitial";
  EStockZeroActions2["SET_86"] = "86";
  EStockZeroActions2["NONE"] = "";
  return EStockZeroActions2;
})(EStockZeroActions || {});

export { EItemDimensionsSellBy, EStockZeroActions, TAllModsBehavior, TCustomizerShape };
